// @ts-check
/**
 * Interface for a Adyen strategy.
 * @typedef {Object} AdyenStrategy
 * @property {function(Object, {adyenToken: string, reference: string, browserInfo: Object}): Promise<Object>} createPayload - Create payment payload.
 */

/**
 * @typedef {import('./CardStrategy').CardStrategy} CardStrategy
 */

/**
 * Adyen card strategy.
 * @function AdyenCardStrategy
 * @returns {CardStrategy}
 */
const AdyenStrategy = () => {
  /**
   * Create a payload for Adyen.
   * @param {Object} cardInfo - The card parameters
   * @param {Object} adyenCardParams - The Adyen card parameters
   * @param {string} adyenCardParams.adyenToken - The Adyen token
   * @param {string} adyenCardParams.reference - The reference
   * @param {Object} adyenCardParams.browserInfo - The browser info
   * @returns {Promise<Object>} The payload
   */
  const createPayload = async (cardInfo, { adyenToken, reference, browserInfo }) => {
    let payload = adyenToken
      ? {
          credit_card_tokens: {
            adyen_token: adyenToken,
          },
        }
      : { recurring_payment_reference: reference };

    payload = {
      ...payload,
      card_holder_name: cardInfo.holderName,
      card_number: cardInfo.cardNumber,
      card_brand: cardInfo.cardBrand,
      browser_info: browserInfo,
    };

    return payload;
  };

  return { createPayload };
};

const adyenStrategy = AdyenStrategy();

export default adyenStrategy;
